import { CART } from '../actions';

const initialState = {
    cartId: null,
    data: [],
    isFetching: false,
    isLoading: false,
    dialogDelete: false,
    deleteData: null,
    dialogStock: false,
    dialogAddProductToCart: false,
    dialogDeleteUnAvailiableItem: false,
    deleteUnAvailiableItem: null,
    dialogBeforeConfirmingOrder: false,
    //checkOutData: null,
    checkoutPromotionSelected: null,
    restItemInCart: null,
    buyNowItem: null,
    buyNow: {
        status: false,
        item: []
    },
    promotion: {
        total: 0,
        items: [],
        promotionCart: [],
        responcePromotionitem: []
    },
    promotionCartSelected: null, 
    colorselected: null,
    sizeselected: null,
    promotiontotal: null,
    discountCode: ""
};

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case CART.CREATE_CART:
            return {
                ...state,
                cartId: payload.data,
                dialogAddProductToCart: payload.dialogAddProductToCart,
                buyNow: {
                    ...state.buyNow,
                    status: false,
                    item: []
                }
            };

        case CART.ADD_OR_UPDATE_PRODUCT_TO_CART:
            return {
                ...state,
                data: payload.data,
                dialogAddProductToCart: payload.dialogAddProductToCart,
                buyNow: {
                    ...state.buyNow,
                    status: false,
                    item: []
                }
            };

        case CART.AUTO_CLOSE_DIALOG_ADD_PRODUCT_TO_CART:
            return { ...state, dialogAddProductToCart: false };

        case CART.CART_DATA_FETCHING:
            return { ...state, isFetching: true };

        case CART.GET_CART_DATA:
            return {
                ...state,
                data: payload.data,
                promotion: payload.promotion,
                
                //checkOutData: null,
                isFetching: false
            };

        case CART.OPEN_DIALOG_DELETE_ITEM_IN_CART:
            return { ...state, dialogDelete: true, deleteData: payload };

        case CART.DELETE_PRODUCT_IN_CART:
            return {
                ...state,
                data: payload.data,
                promotion: payload.promotion,
                dialogDelete: false,
                deleteData: null
            };

        case CART.CLOSE_DIALOG_DELETE_ITEM_IN_CART:
            return { ...state, dialogDelete: false, deleteData: null };

        case CART.OPEN_DIALOG_ITEM_OVER_STOCK:
            return { ...state, dialogStock: true };

        case CART.CLOSE_DIALOG_ITEM_OVER_STOCK:
            return { ...state, dialogStock: false };

        case CART.UPDATE_PRODUCT_IN_CART_PENDING:
            return { ...state, isLoading: true };

        case CART.UPDATE_PRODUCT_IN_CART:
            return {
                ...state,
                isLoading: false,
                data: payload.data,
                promotion: payload.promotion
            };

        case CART.DESTROY_CART:
            return {
                ...state,
                data: [],
                dialogDelete: false,
                deleteData: null
            };

        case CART.ADD_PRODUCT_TO_CART:
            return { ...state, data: payload };

        case CART.OPEN_DIALOG_DELETE_UNAVAILIABLE_ITEM:
            return {
                ...state,
                dialogDeleteUnAvailiableItem: true,
                deleteUnAvailiableItem: payload
            };

        case CART.DELETE_UNAVAILIABLE_ITEM:
            return {
                ...state,
                data: payload.data,
                promotion: payload.promotion,
                dialogDeleteUnAvailiableItem: false,
                deleteUnAvailiableItem: null
            };

        case CART.CLOSE_DIALOG_DELETE_UNAVAILIABLE_ITEM:
            return {
                ...state,
                dialogDeleteUnAvailiableItem: false,
                deleteUnAvailiableItem: null
            };

        case CART.OPEN_DIALOG_BEFORE_CONFIRMING_ORDER:
            return { ...state, dialogBeforeConfirmingOrder: true };

        case CART.CLOSE_DIALOG_BEFORE_CONFIRMING_ORDER:
            return { ...state, dialogBeforeConfirmingOrder: false };

        case CART.CHECK_OUT_DATA:
            return {
                ...state,
                buyNow: state.buyNow,
                // checkOutData: payload.checkOutData,
                restItemInCart: payload.restItemInCart,
                checkoutPromotionSelected: payload.checkoutPromotionSelected,
                
                promotionCartSelected: payload.promotionCartSelected, 
                colorselected: payload.colorselected,
                sizeselected: payload.sizeselected,
                promotiontotal: payload.promotiontotal
            };

        case CART.ADD_BUY_NOW_ITEM:
            return { ...state, buyNowItem: payload };

        case CART.CLEAR_BUY_NOW_ITEM:
            return { ...state, buyNowItem: null, discountCode: "" };

        case CART.ADD_BUY_NOW:
            return {
                ...state,
                dialogAddProductToCart: payload.dialogAddProductToCart,
                buyNow: {
                    ...state.buyNow,
                    status: true,
                    item: payload.data
                }
            }
        case CART.UPDATE_BUY_NOW:
            return {
                ...state,
                buyNow: {
                    ...state.buyNow,
                    status: true,
                    item: payload
                }
            }
        case CART.CLEAR_BUY_NOW:
            return {
                ...state,
                //checkOutData: null,
                dialogDelete: false,
                buyNow: {
                    ...state.buyNow,
                    status: payload.length > 0,
                    item: payload
                }
            }

        case CART.UPDATE_PROMOTION_PENDING:
            return { ...state, isLoading: true }
        case CART.UPDATE_PROMOTION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                promotion: payload.promotion,
                discountCode: payload.discountCode,
                data: payload.data,
                dialogDelete: false,
                deleteData: null
            }
        case CART.UPDATE_PROMOTION_FALIED:
            return {
                ...state,
                isLoading: false,
                promotion: {},
                data: [],
                dialogDelete: false,
                deleteData: null
            }

        case CART.CLEAR_DISCOUNT_CODE:
            return {
                ...state,
                discountCode: ""
            }

        default:
            return state;
    }
};
